import { getPacks } from '../peijian/all'

export default {
  name: 'igs-28se',
  // 图文
  imageText: [
    // 主图1
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-1.png',
    },
    {
      type: 'formwork9',
      list: [
        {
          id: 'a-1',
          text: '1、Powerful grow lights, talllamp arm, highwater capacity, large grow deck, and detachable trellis',
        },
        { id: 'a-2', text: '2、Grow up to 6 plants, 5x faster than soil' },
        { id: 'a-3', text: '3、15.6W LED grow light for patent spectrum,optimallighting' },
        {
          id: 'a-4',
          text: '4、Adjusts for up to 21.5" of grow height soyou can grow big plants and features alarger bowl to hold more water than the base Harvest',
        },
        { id: 'a-5', text: '5、Touch-sensitive illuminated controlpanel & care indicators' },
        { id: 'a-6', text: '6、Easy, automatic reminders for water &plant food' },
      ],
    },
    // 配件
    {
      type: 'formwork5',
      packs: getPacks([
        { id: 'accessories-6', num: 6 },
        { id: 'accessories-7', num: 6 },
        { id: 'accessories-8', num: 6 },
        { id: 'accessories-9', num: 6 },
        { id: 'accessories-11', num: 1 },
        { id: 'accessories-12', num: 1 },
        { id: 'accessories-17', num: 1 },
      ]),
    },
    // 主图2
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-2.png',
    },
    // 参数
    {
      type: 'formwork6',
      specifications: [
        { id: '2-1', name: 'Product Specifications:', value: '311*140*210(H)(lowest)/545(highest)mm' },
        { id: '2-2', name: 'Adapter Specifications Input:', value: '100V-240V/50-60HZ' },
        { id: '2-3', name: 'Colour:', value: 'Black / White' },
        { id: '2-4', name: 'Water Tank Capacity:', value: '2.5L' },
        { id: '2-5', name: 'Neludes:', value: '6pcs pod kit / 1 water pumps' },
        { id: '2-6', name: 'LED Light:', value: 'Specific Spectrum' },
        { id: '2-7', name: 'Color box Size:', value: '335x235x160mm' },
        { id: '2-8', name: 'Product Weight:', value: '1.25kg' },
        { id: '2-9', name: 'Output:', value: '24V' },
        { id: '2-10', name: 'Power:', value: '15W' },
        { id: '2-11', name: 'Number of Plants:', value: '6pods' },
        { id: '2-12', name: 'Product Type:', value: 'Hydroponic' },
        { id: '2-13', name: 'Lamp Beads:', value: 'White:30 Red:15 Blue:7' },
        { id: '2-14', name: 'Outer box Size:', value: '500x350x490mm' },
      ],
    },
    // 主图3
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-3.png',
    },
    // 产品视图
    {
      type: 'formwork8',
      list: [
        {
          id: '4-1',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-shitu/IGS-28SE-ceshitu.png',
        },
        {
          id: '4-2',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-shitu/IGS-28SE-fushitu.png',
        },
        {
          id: '4-3',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-shitu/IGS-28SE-zhengshitu.png',
        },
        {
          id: '4-4',
          img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-shitu/IGS-28SE-zhengshitu1.png',
        },
      ],
    },
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-28SE/IGS-28SE-chanpinzhuanli.png',
    },
  ],
}
